export default __webpack_public_path__ + "KaTeX_AMS-Regular.f80d9eaff7bad6dad7396a98fc016ce2.ttf";